import { jsx as _jsx } from "react/jsx-runtime";
import { LogoutOutlined } from "@ant-design/icons";
function confirmLogout(t, rcbAuthenticationStore, navigate, { modal, notification }) {
    modal.confirm({
        title: t("Logout"),
        icon: /*#__PURE__*/ _jsx(LogoutOutlined, {}),
        content: t("Press logout to continue."),
        okText: t("Logout"),
        centered: true,
        onOk () {
            rcbAuthenticationStore.sessionLogout(()=>{
                navigate("/rcb/login");
                notification.success({
                    message: t("Logout successful!"),
                    duration: 5
                });
            });
        }
    });
}
export { confirmLogout };
